import axiosInstance from "./axiosInstance";
import { api } from "./api_route";

export const searchAgreements = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${api}/meetings/search`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const saveMeeting = async (meetingData) => {
  try {
    const response = await axiosInstance.post(
      `${api}/meetings/create`,
      meetingData,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateMeeting = async (meetingId, meetingData) => {
  try {
    const response = await axiosInstance.put(
      `${api}/meetings/update/${meetingId}`,
      meetingData,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const listMeetings = async (payload) => {
  try {
    const response = await axiosInstance.post(`${api}/meetings/list`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const viewMeeting = async (meetingId) => {
  try {
    const response = await axiosInstance.get(`${api}/meetings/${meetingId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getMeetingStatusOptions = async () => {
  try {
    const response = await axiosInstance.get(`${api}/meetings/status-options`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteMeeting = async (meetingId) => {
  try {
    const response = await axiosInstance.delete(
      `${api}/meetings/delete/${meetingId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
